import { render, staticRenderFns } from "./lawyerEmpty.vue?vue&type=template&id=145c4a42&scoped=true"
import script from "./lawyerEmpty.vue?vue&type=script&lang=js"
export * from "./lawyerEmpty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145c4a42",
  null
  
)

export default component.exports